import { TypographyProps } from 'styled-system'

export type TableCellFontOptions = 'lg' | 'md'

export interface TableCellFontVariantsProps {
  lg: TypographyProps
  md: TypographyProps
}

export const TABLE_CELL_FONT_VARIANTS: TableCellFontVariantsProps = {
  lg: {
    fontSize: '15px',
    lineHeight: 1.67
  },
  md: {
    fontSize: '13px',
    lineHeight: 1.77
  }
}
